import { useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/colors";

const StyledDiv = withViewportStyle("div")`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  width: calc(100% / 3);
  padding: ${rem(32)} ${rem(24)};
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};

  .image-primitive {
    width: ${rem(100)};
    height: ${rem(100)};
    object-fit: scale-down;
    background: white;
    border-radius: ${rem(8)};
    margin-bottom: ${rem(16)};
  }

  .text-primitive.headingThree {
    margin-bottom: ${rem(8)};  
  }

  ${(props) => props.$viewport.tablet`
    width: 50%;
  `}

  ${(props) => props.$viewport.mobile`
    width: 100%;
    padding: ${rem(24)} ${rem(16)};
  `}
`;

export type BenefitCardProps = {
  children: React.ReactNode;
};

export default function BenefitCard(props: BenefitCardProps) {
  const {
    connectors: { connect },
  } = useNode();

  return <StyledDiv ref={connect}>{props.children}</StyledDiv>;
}

BenefitCard.craft = {
  isCanvas: true,
  custom: {
    displayName: "Benefit Card",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};
